/*
 * Spaces Messages
 *
 * This contains all the text for the Spaces container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.Spaces';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Spaces',
  },
  totalSpaces: {
    id: `${scope}.totalSpaces`,
    defaultMessage: 'spaces total',
  },
  addSpace: {
    id: `${scope}.addSpace`,
    defaultMessage: 'Add space',
  },
  spaceDetails: {
    id: `${scope}.spaceDetails`,
    defaultMessage: 'Space Details',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  space: {
    id: `${scope}.space`,
    defaultMessage: 'Space',
  },
  fName: {
    id: `${scope}.fName`,
    defaultMessage: 'First Name',
  },
  lName: {
    id: `${scope}.lName`,
    defaultMessage: 'Last Name',
  },
  sex: {
    id: `${scope}.sex`,
    defaultMessage: 'Sex',
  },
  birth: {
    id: `${scope}.birth`,
    defaultMessage: 'Birth',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  phNumber: {
    id: `${scope}.phNumber`,
    defaultMessage: 'Phone',
  },
  enrolled: {
    id: `${scope}.enrolled`,
    defaultMessage: 'Enrolled',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  active: {
    id: `${scope}.active`,
    defaultMessage: 'Active',
  },
  inactive: {
    id: `${scope}.inactive`,
    defaultMessage: 'Inactive',
  },
  male: {
    id: `${scope}.male`,
    defaultMessage: 'Male',
  },
  female: {
    id: `${scope}.female`,
    defaultMessage: 'Female',
  },
});
